import styled from 'styled-components';
import { getFontStyle } from '~components/Text/helper';

interface LegendProps {
  backgroundColor: string;
}

export const Wrapper = styled.div`
  display: flex;
  justify-content: center;
  gap: 0 16px;
  margin: 16px 0;
`;

export const Legend = styled.div<LegendProps>`
  display: flex;
  align-items: center;
  color: ${({ theme }) => theme.colors.gray800};
  white-space: nowrap;

  &::before {
    content: '';
    display: block;
    width: 9px;
    height: 9px;
    margin-right: 4px;
    background-color: ${({ backgroundColor }) => backgroundColor};
  }

  ${getFontStyle('midium120_C1')};
`;
